import { formatNumber } from "../../../util/varibles/global";
import { IUnit } from "../../../util/varibles/interface";
import styles from "./style.module.scss";

export default function FishUnitInfo({ unit }: { unit?: IUnit }) {
    return <div className={styles.fishInfo}>
        <div className={styles.subFishInfo}>
            <div data-lev='title'>Avg. weight:</div>
            <div>{formatNumber(unit?.avg_weight)} gr</div>
        </div>
        <div className={styles.subFishInfo}>
            <div data-lev='title'>Amount:</div>
            <div>{formatNumber(unit?.fish_amount)}</div>
        </div>
        <div className={styles.subFishInfo}>
            <div data-lev='title'>Total weight:</div>
            <div>{formatNumber(Math.round((unit?.total_weight || 1) / 1000) / 1000)} t</div>
        </div>
    </div>
}